<template>
  <div>
    <!-- menu -->
    <nav class="horoscope__nav horoscope-nav" :class="{'sticky': sticky}">
      <div class="container horoscope-nav__container">
        <div class="row no-gutters horoscope-nav__row">
          <a
            href="#"
            role="button"
            class="horoscope-nav__item horoscope-nav__item--active"
            @click.prevent="openFirstMenu = !openFirstMenu"
            :class="{'zindex': openFirstMenu}"
          >
            <img :src="require(`../assets/img/interpretation/${type}.png`)">
          </a>
          <a
            href="#"
            role="button"
            class="horoscope-nav__item"
            @click.prevent="openSecondMenu = !openSecondMenu"
            :class="{'zindex': openSecondMenu}"
          >
            <div class="horoscope-nav__letter">
              <span>{{letterName}}</span>
            </div>
          </a>
        </div>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--first"
            v-if="openFirstMenu"
            @click="openFirstMenu = !openFirstMenu"
          >
            <router-link
              v-for="(item, index) in interpretationList"
              :key="index"
              :to="`/imena/${item.id}/`"
              :class="{'router-link-exact-active': routePath.indexOf(`/${item.id}/`) !== -1 ? true : false}"
            >
              <img :src="require(`../assets/img/interpretation/${item.id}.png`)" :alt="item.name">
              {{item.name}}
            </router-link>
            <router-link
              to="/imena/whatname/"
              :class="{'router-link-exact-active': routePath.indexOf(`/whatname/`) !== -1 ? true : false}"
            >
              <img
                :src="require(`../assets/img/interpretation/whatname.png`)"
                alt="Как назвать ребенка"
              >Как назвать ребенка
            </router-link>
          </nav>
        </transition>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--second"
            v-if="openSecondMenu"
            @click="openSecondMenu = !openSecondMenu"
          >
            <router-link
              v-for="(item, index) in alphabet"
              :key="index"
              :to="`/imena/${type}/${item.id}/`"
            >{{item.name}}</router-link>
          </nav>
        </transition>
      </div>
      <transition name="fade">
        <div class="overlay" v-if="openFirstMenu" @click="openFirstMenu = false"></div>
      </transition>
      <transition name="fade">
        <div class="overlay" v-if="openSecondMenu" @click="openSecondMenu = false"></div>
      </transition>
    </nav>
    <!-- /menu -->
    <div class="container" :class="{'sticky-next': sticky}">
      <Loader v-if="loading"/>
      <template v-else>
        <div class="dreambooks__breadcrumbs mb-4">{{typeName}} / {{letterName}}</div>
        <div class="row">
          <div class="col mb-4">
            <div class="dream-words">
              <template v-if="names.length">
                <ul class="dream-words__list">
                  <li v-for="(item, index) in names1" :key="index" class="dream-words__item">
                    <router-link
                      :to="`/imena/${type}/${letter}/${item.id}/`"
                      class="dream-words__link link"
                    >{{item.name}}</router-link>
                  </li>
                </ul>
                <ul class="dream-words__list">
                  <li v-for="(item, index) in names2" :key="index" class="dream-words__item">
                    <router-link
                      :to="`/imena/${type}/${letter}/${item.id}/`"
                      class="dream-words__link link"
                    >{{item.name}}</router-link>
                  </li>
                </ul>
              </template>
              <p
                v-else
                class="text-center not-found-word"
              >Имени, начинающиегося на эту букву, не найдено.</p>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item">
          <div class="col">
            <div
              class="dreambooks__select-title dreambooks__select-title--gray"
            >На какую букву начинается имя</div>
            <div class="dreambooks__list dreambooks__list--gray">
              <router-link
                v-for="(item, index) in alphabet"
                :key="index"
                :to="`/imena/${type}/${item.id}/`"
              >{{item.name}}</router-link>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item">
          <div class="col">
            <div class="dreambooks__select-title dreambooks__select-title--gray">Выберите категорию</div>
            <div class="dreambooks__list dreambooks__list--gray dreambooks__list--nemu">
              <router-link
                v-for="(item, index) in interpretationList"
                :key="index"
                :to="`/imena/${item.id}/`"
                :class="{'router-link-exact-active': routePath.indexOf(`/${item.id}/`) !== -1 ? true : false}"
              >
                <img :src="require(`../assets/img/interpretation/${item.id}.png`)" :alt="item.name">
                {{item.name}}
              </router-link>
              <router-link to="/imena/whatname/">
                <img :src="require(`../assets/img/interpretation/whatname.png`)" alt="Что сбудется">Как назвать ребенка
              </router-link>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item" v-if="type !== 'male'">
          <div class="col">
            <div class="dreambooks__select-title dreambooks__select-title--pink">Мужское имя</div>
            <div class="dreambooks__list dreambooks__list--pink">
              <router-link
                v-for="(item, index) in alphabet"
                :key="index"
                :to="`/imena/male/${item.id}/`"
              >{{item.name}}</router-link>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item" v-if="type !== 'female'">
          <div class="col">
            <div class="dreambooks__select-title dreambooks__select-title--pink">Женское имя</div>
            <div class="dreambooks__list dreambooks__list--pink">
              <router-link
                v-for="(item, index) in alphabet"
                :key="index"
                :to="`/imena/female/${item.id}/`"
              >{{item.name}}</router-link>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item" v-if="type !== 'child'">
          <div class="col">
            <div class="dreambooks__select-title dreambooks__select-title--pink">Имя ребенка</div>
            <div class="dreambooks__list dreambooks__list--pink">
              <router-link
                v-for="(item, index) in alphabet"
                :key="index"
                :to="`/imena/child/${item.id}/`"
              >{{item.name}}</router-link>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="container">
      <div class="row">
        <div class="col">
          <router-link to="/imena/" class="back-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 31.494 31.494"
              style="enable-background:new 0 0 31.494 31.494;"
              xml:space="preserve"
              width="15px"
              height="15px"
            >
              <path
                d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554  c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587  c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                fill="#ff00a4"
              ></path>
            </svg>
            Вернуться на главную раздела
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import setSticky from "../setSticky.js";
export default {
  components: {
    Loader
  },
  data() {
    return {
      routePath: this.$route.path,
      openFirstMenu: false,
      openSecondMenu: false,
      typeName: "",
      letterName: "",
      type: this.$route.params.type,
      letter: this.$route.params.slug,
      sticky: false
    };
  },
  metaInfo () {
    return {
      title: this.titleName.title,
      meta: [
        { name: 'description', content: this.titleName.description },
        { name: 'keywords', content: this.titleName.keywords }
      ]
    }
  },
  computed: {
    titleName() {
      switch (this.type) {

        case "male":
          return {
            title: `${this.letterName} - Мужские имена - Значения мужских имен - Список мужских имен`,
            description: `Мужские имена. Значение мужского имени. Влияние имени на характер и судьбу. Большой список мужских имен. Значение и происхождение имен на orakul.com`,
            keywords: `мужские имена, значение имени, тайна имени, значения, имен, список имен, русские, имя мальчика, значение мужских имен`
          };
        
        case "female":
          return {
            title: `${this.letterName} - Женские имена - Значения женских имен - Список женских имен`,
            description: `Женские имена. Значение женского имени. Влияние имени на характер и судьбу. Большой список женских имен. Значение и происхождение имен на orakul.com`,
            keywords: `женские имена, значение имени, тайна имени, значения, имен, список имен, русские, имя девочки`
          };
        
        case "child":
          return {
            title: `${this.letterName} - Имя для ребенка -  Каталог имен детей`,
            description: `Значение имени. Мужские имена. Влияние имени на характер и судьбу. Выбери имя ребенку, имя для мальчика, большой список имен. Значение и происхождение имен на orakul.com`,
            keywords: `имя ребенка, имена ребенку, имя ребенку, детские имена, значение имени, тайна имени, значения, имен, список имен, русские`
          };

        case "whatname":
          return {
            title: `Значение имени - Что означает имя - Выбор имени - Список имен`,
            description: `Значение имени. Мужские и женские имена. Влияние имени на характер и судьбу. Выбери имя ребенку, большой список имен: имя мальчика, имя девочки. Значение и происхождение имен на orakul.com`,
            keywords: `значение имени, тайна имени, значения, имен, женские имена, мужские имена, список имен, русские, имя девочки, имя мальчика`
          };
        
        default:
          return {
            title: "Значение имени - Что означает имя - Выбор имени - Список имен на orakul.com",
            description: "Значение имени. Мужские и женские имена. Влияние имени на характер и судьбу. Выбери имя ребенку, большой список имен: имя мальчика, имя девочки. Значение и происхождение имен на orakul.com",
            keywords: "значение имени, тайна имени, значения, имен, женские имена, мужские имена, список имен, русские, имя девочки, имя мальчика"
          };
      }
    },
    firstMenu() {
      return this.$store.state.interpretation.firstMenu;
    },
    alphabet() {
      return this.$store.state.interpretation.alphabet;
    },
    names() {
      return this.$store.state.interpretation.names;
    },
    names1() {
      return this.$store.getters["interpretation/names1"];
    },
    names2() {
      return this.$store.getters["interpretation/names2"];
    },
    interpretationList() {
      return this.$store.getters["interpretation/interpretationList"];
    },
    loading() {
      return this.$store.state.interpretation.loading;
    }
  },
  methods: {
    getNames() {
      this.$store.dispatch("interpretation/getNames", {
        command: "getnames",
        type: this.type,
        slug: this.letter
      });
    },
    getTypeName(type) {
      switch (type) {
        case "male":
          this.typeName = "Мужское имя";
          break;
        case "female":
          this.typeName = "Женское имя";
          break;
        case "child":
          this.typeName = "Имя ребенка";
          break;
        case "whatname":
          this.typeName = "Как назвать ребенка";
          break;
        default:
          this.typeName = "";
      }
    },
    getLetter(letter) {
      this.letterName = this.alphabet.filter(item => {
        return item.id === letter;
      })[0].name;
    }
  },
  watch: {
    $route(to) {
      this.routePath = to.path;
      this.type = to.params.type;
      this.letter = to.params.slug;
      this.getTypeName(this.type);
      this.getLetter(this.letter);
      this.getNames();
    }
  },
  created() {
    if (!navigator.onLine) {
      this.$router.push("/offline");
    } else {
      this.getNames();
      this.getTypeName(this.type);
      this.getLetter(this.letter);
    }

    setSticky.call(this);
  }
};
</script>

<style lang="scss" scoped>
.not-found-word {
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: #333;
}
.horoscope-nav__item:first-child img {
  width: 65px;
}
.horoscope-menu a img {
  left: 7px;
}
.horoscope-menu--first {
  i {
    height: 63px;
  }
}
.horoscope-nav__letter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f1f4f6;
  span {
    color: #00acff;
    font-size: 23px;
    font-weight: 900;
  }
}
.dream-words {
  display: flex;
}
.dream-words__list {
  margin: 0;
  padding: 0;
  list-style: none;
  width: 49%;
}
.dream-words__item {
  margin-bottom: 20px;
}
.dream-words__link {
  font-size: 18px;
  font-weight: 400;
}
.horoscope-menu--first {
  a {
    width: 25%;
  }
}

.horoscope-menu--second {
  justify-content: center;
  a {
    color: #511079;
    font-size: 18px;
    line-height: 18px;
    font-weight: 400;
    border: 2px solid transparent;
    display: block;
    text-align: center;
    width: calc(100% / 8);
    padding: 15px 3px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: #000;
      border-radius: 3px;
      border: 2px solid #ff00a4;
    }
  }
}
.dreambooks__breadcrumbs {
  font-size: 18px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}
.dreambooks__breadcrumbs {
  font-size: 18px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}
.horoscope-menu--first a {
  width: 25%;
}

.dreambooks__select-title {
  padding: 20px 15px;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
}

.dreambooks__select-title--gray {
  background: #f1f4f6;
  color: #333;
}

.dreambooks__select-title--pink {
  background: #f9f1fe;
  color: #511079;
}

.dreambooks__select-item {
  margin-bottom: 25px;
}

.dreambooks__list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 7px;
  width: 100%;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    content: "";
  }
  a {
    color: #511079;
    font-size: 18px;
    line-height: 18px;
    font-weight: 400;
    border: 2px solid transparent;
    display: block;
    text-align: center;
    width: calc(100% / 8);
    padding: 15px 3px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: #000;
      border-radius: 3px;
      border: 2px solid #ff00a4;
    }
    img {
      display: block;
      width: 50px;
      height: auto;
      margin: 0 auto;
      position: relative;
      left: 7px;
      // margin-bottom: 7px;
      // border-radius: 50%;
      // box-shadow: 0 0 8px 4px #ccd6db;
    }
  }
}
.dreambooks__list--words {
  justify-content: space-between;
  a {
    display: block;
    width: 49%;
    text-align: left;
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    padding: 5px 3px;
  }
}
.dreambooks__list--nemu a {
  color: #777;
  font-size: 10px;
  line-height: 10px;
  font-weight: 700;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 25%;
  padding: 10px 3px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &.router-link-exact-active {
    color: #000;
    border-radius: 3px;
    border: 2px solid #ff00a4;
  }
  i {
    margin-bottom: 7px;
  }
}
.dreambooks__list--gray {
  background: #f1f4f6;
  &::after {
    box-shadow: 0 -80px 60px 60px #6d90a1;
  }
}
.dreambooks__list--pink {
  background: #f9f1fe;
  &::after {
    box-shadow: 0 -80px 60px 60px #c67af5;
  }
}
</style>
